"use client";

export default function ContactForm() {
  return (
    <div className="flex flex-col items-center justify-center w-full bg-primary rounded-xl text-white py-8 px-4 sm:py-12 md:py-16">
      <div className="w-full max-w-md space-y-4 sm:space-y-6">

        {/* Form */}
        <form className="flex flex-col space-y-4 sm:space-y-5">

            <div>
                <label htmlFor="name" className="block text-sm sm:text-base mb-2 sm:mb-4">Name</label>
                <input id="name" type="text" placeholder="Your Name..."
                className="w-full bg-transparent border border-gray-200 rounded-md py-2.5 sm:py-3 px-3 sm:px-4 text-sm sm:text-base text-white placeholder-gray-200 focus:outline-none focus:border-white"
                />
            </div>

            <div>
                <label htmlFor="email" className="block text-sm sm:text-base mb-2">Email</label>
                <input id="email" type="email" placeholder="example@youremail.com"
                className="w-full bg-transparent border border-gray-200 rounded-md py-2.5 sm:py-3 px-3 sm:px-4 text-sm sm:text-base text-white placeholder-gray-200 focus:outline-none focus:border-white"
                />
            </div>

            <div>
                <label htmlFor="subject" className="block text-sm sm:text-base mb-2">Subject</label>
                <input id="subject" type="text" placeholder="Title..."
                className="w-full bg-transparent border border-gray-200 rounded-md py-2.5 sm:py-3 px-3 sm:px-4 text-sm sm:text-base text-white placeholder-gray-200 focus:outline-none focus:border-white"
                />
            </div>

          <div>
            <label htmlFor="message" className="block text-sm sm:text-base mb-2">Message</label>
            <textarea id="message" rows={3} placeholder="Type here..."
              className="w-full bg-transparent border border-gray-200 rounded-md py-2.5 sm:py-3 px-3 sm:px-4 text-sm sm:text-base text-white placeholder-gray-200 focus:outline-none focus:border-white resize-none"
            />
          </div>

          <button type="submit" className="mt-2 py-2.5 sm:py-3 w-full text-sm sm:text-base text-white rounded-full bg-accent hover:bg-accent transition-all duration-300"
          >
            Send Now
          </button>
        </form>
      </div>
    </div>
  );
}